<template>
    <div class="quizPage">
        <logo modifier="logo--quiz"></logo>
        <quiz></quiz>
    </div>
</template>

<script>
    import Quiz from '@/components/quiz/QuizElement';
    import Logo from '@/components/shared/LogoElement';

    export default {
        name: 'Quiz',
        components: {
            'quiz': Quiz,
            'logo': Logo
        }
    }
</script>

<style lang="scss">
    .quizPage {
        height: 100vh;
        width: 100%;
        background: url('~@/assets/images/background-gray.png');
        text-align: center;
    }
</style>

